<template lang="pug">
k-main.admin-edit.admin-edit-media
  template( #title )
    .title
      h1.title {{ title }}
      k-actions.header-actions( :actions='actions' :icons='icons' @exec='doAction' )
  .main-content( v-bar )
    .inner
      f-string(
        label='Title'
        :value=`formData.title || ''`
        @input=`update( $event, 'title' )`
      )
      section
        k-video-player( :content='postData' )
      section
        f-text(
          label='Caption'
          :value=`formData.caption || ''`
          @change=`update( $event, 'caption' )`
        )
        f-text(
          label='Description'
          :value=`formData.description || ''`
          @change=`update( $event, 'description' )`
        )
        f-collections(
          label='In collections'
          :value='formData.collections'
          @input=`update( $event, 'collections' )`
        )
        f-tags(
          label='Tags'
          :value='formData.attachment_tag'
          @input=`update( $event, 'tags' )`
        )
        f-content-restrictions(
          :value='formData.restrictions'
          @input=`update( $event, 'restrictions' )`
        )
  k-actions.footer-actions(
    :actions='actions'
    :icons='icons'
    type='icon-text'
    @exec='doAction'
  )
</template>

<script lang="js">
import isObject from 'lodash-es/isObject'
import { mapState, mapActions } from 'vuex'
import KActions from '@/blocks/k-actions'
import KForm from '@/blocks/k-form'
import KMain from '@/blocks/k-main'
import KVideoPlayer from '@/blocks/k-video-player'
import icons from '@/icons'
import fields from '@/fields'
import { Logger } from '@/lib/logger'
import { preprocessActions } from '@/lib/util'

export default {
  name: 'AdminEditMediaPage',
  mixins: [],
  components: {
    KActions,
    KForm,
    KMain,
    KVideoPlayer,
    ...fields
  },
  props: {
    post: {
      type: Object,
      default: () => ({})
    },
    model: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      icons,
      postData: {},
      edits: {}
    }
  },
  created() {
    this.setPostData( this.post.data )
  },
  mounted() {},
  methods: {
    ...mapActions([ 'getModelObject', 'updateModelObject' ]),
    setPostData( data ) {
      const postData = Object.assign( {}, data )
      if ( isObject( postData.title )) {
        postData.title = postData.title.raw || ''
      }
      if ( isObject( postData.caption )) {
        postData.caption = postData.caption.raw || ''
      }
      if ( isObject( postData.description )) {
        postData.description = postData.description.raw || ''
      }
      postData.collections = [
        ...( data.attachment_category || []),
        ...( data.collection || [])
      ]
      postData.tags = [
        ...( data.attachment_tag || []),
        ...( data.tag || [])
      ]
      this.postData = postData
    },
    update( value, section ) {
      this.$set( this.edits, section, value )
    },
    doAction({ fn, action, item }) {
      Logger.debug('doAction', '<AdminEditMediaPage>', {
        fn, action, item, thisFn: this[ fn ]
      })()
      if ( this[ fn ]) {
        return this[ fn ]()
      }
    },
    async revert() {
      // const object = this.getModelObject({ model: 'Media', id: this.postData.id })
      this.edits = {}
    },
    async commit() {
      const { collections, tags, restrictions, ...edits } = this.edits
      const terms = {
      }
      if ( collections ) {
        terms.attachment_category = []
        terms.collection = []
        for ( const term of collections ) {
          if ( !terms[ term.taxonomy ]) {
            terms[ term.taxonomy ] = []
          }
          terms[ term.taxonomy ].push( term.id )
        }
      }
      if ( tags ) {
        terms.attachment_tag = []
        for ( const term of tags ) {
          if ( !terms[ term.taxonomy ]) {
            terms[ term.taxonomy ] = []
          }
          terms[ term.taxonomy ].push( term.id )
        }
      }
      if ( restrictions ) {
        const orig = this.postData.restrictions
        const meta = {}
        const { product, users, preview, show, ...rest } = restrictions
        if ( product !== orig.product ) {
          meta.associated_product = isObject( product ) ? product.id : product
        }
        if ( preview !== orig.preview ) {
          meta.preview_content = isObject( preview ) ? preview.id : preview
        }
        if ( show !== orig.show ) {
          meta.can_see = show
        }
        meta.users_allowed = ( users || []).map( u => ( isObject(u) ? u.id : u ))
        meta.restrictions = Object.keys( rest ).filter( k => rest[k] )
        edits.meta = meta
      }
      const result = await this.updateModelObject({ 
        model: 'Media', 
        id: this.postData.id,
        ...edits,
        ...terms,
        sync: true,
      })
      // TODO: catch error?
      if ( result ) {
        this.edits = {}
        this.setPostData( result )
      }
      return result
    },
  },
  computed: {
    // ...mapState([ 'post' ]),
    actions() {
      return ( this.post && this.post.actions ) || []
    },
    sections() {
      return this.thisSections || ( this.post && this.post.sections ) || []
    },
    objects() {
      return  this.thisObjects || ( this.post && this.post.objects ) || []
    },
    title() {
      return ( this.post && this.post.title ) || 'Content'
    },
    formData() {
      return Object.assign({}, this.postData, this.edits )
    }
  }
}
</script>

<style lang="scss">
.admin-edit-media {
  .k-video-player {
    .video-js {
      position: relative;
    }
  }
  section {
    text-align: left;
  }
}
</style>
